import React from 'react';
import { useAppContext } from '../context/AppContext';
import { mascotSrc } from '../utils/avatars';

interface AntMascotProps {
  /** Kept for callers; the picture is the same for every pose. */
  pose?: 'wave' | 'celebrate';
  className?: string;
}

/**
 * The ant that talks to the family (messages, empty states, goals): the Queen ant from Jens's
 * avatar series, or — once the grown-up who started the family picks a picture — that picture.
 */
const AntMascot: React.FC<AntMascotProps> = ({ className = 'w-24 h-24' }) => {
  const { current_family } = useAppContext() as any;
  return <img src={mascotSrc(current_family)} alt="" aria-hidden className={`${className} object-contain`} draggable={false} />;
};

export default AntMascot;
